/**
 * True when the app is running embedded (the floating assistant "widget" / copilot iframe)
 * rather than as the standalone full SPA. The host-page embed loads the app via the
 * `/copilot` route, so both `/widget/` and `/copilot` (and their `mode=` query variants)
 * count as widget mode here.
 */
export function isWidgetMode(): boolean {
    return (
        window.location.hash.includes("/widget/") ||
        window.location.hash.includes("/copilot") ||
        window.location.search.includes("mode=widget") ||
        window.location.search.includes("mode=copilot")
    );
}
